import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

export type ToastSeverity = 'success' | 'info' | 'warn' | 'error';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  /**
   * Muestra un mensaje de éxito
   */
  success(detail: string, summary: string = 'Éxito'): void {
    this.show('success', summary, detail);
  }

  /**
   * Muestra un mensaje informativo
   */
  info(detail: string, summary: string = 'Información'): void {
    this.show('info', summary, detail);
  }

  /**
   * Muestra un mensaje de advertencia
   */
  warn(detail: string, summary: string = 'Advertencia'): void {
    this.show('warn', summary, detail);
  }

  /**
   * Muestra un mensaje de error
   */
  error(detail: string, summary: string = 'Error'): void {
    this.show('error', summary, detail);
  }

  /**
   * Muestra un mensaje genérico
   */
  show(severity: ToastSeverity, summary: string, detail: string, life: number = 5000): void {
    this.messageService.add({
      severity,
      summary,
      detail,
      life
    });
  }

  /**
   * Limpia todos los mensajes
   */
  clear(): void {
    this.messageService.clear();
  }
}
